module.exports = __webpack_public_path__ + "img/bills.af2d028e.png";